export const sendPostMessageToParent = ({
  value,
  action
}) => {
  window.parent.postMessage({
    value,
    action
  }, '*');
};